
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BentoBoxById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bentoBox"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"informationText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageGradient"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageWithFocalPointFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"portraitBackgroundImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageWithFocalPointFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundMedia"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"portraitBackgroundMedia"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"actionButton"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actionButtonText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actionButtonUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actionButtonAction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"callOutSticker"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"callOutStickerTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"callOutStickerSubtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"callOutStickerOverline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyBrandSubrand"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wholeBoxUrlLink"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":728}};
    doc.loc.source = {"body":"#import \"./fragments/ImageWithFocalPointFields.graphql\"\n\nquery BentoBoxById($id: String!) {\n  bentoBox(id: $id) {\n    sys {\n      id\n    }\n    title\n    subtitle\n    overline\n    informationText\n    imageGradient\n    backgroundImage {\n      ...ImageWithFocalPointFields\n    }\n    portraitBackgroundImage {\n      ...ImageWithFocalPointFields\n    }\n    backgroundMedia {\n      url\n      title\n    }\n    portraitBackgroundMedia {\n      url\n      title\n    }\n    actionButton\n    actionButtonText\n    actionButtonUrl\n    actionButtonAction\n    leadMessage\n    callOutSticker\n    callOutStickerTitle\n    callOutStickerSubtitle\n    callOutStickerOverline\n    companyBrandSubrand\n    backgroundColor\n    tags\n    wholeBoxUrlLink\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./fragments/ImageWithFocalPointFields.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["BentoBoxById"] = oneQuery(doc, "BentoBoxById");
        
